import { render, staticRenderFns } from "./ShowCustomerLayout.vue?vue&type=template&id=64c12940&scoped=true"
import script from "./ShowCustomerLayout.vue?vue&type=script&lang=js"
export * from "./ShowCustomerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c12940",
  null
  
)

export default component.exports